import { type MantineColorsTuple, createTheme } from '@mantine/core';

/**
 * Accent palette generated around #126b57 (PRD §10.1).
 * Shade 7 = #126b57 (--accent), shade 8 = #0f5a4a (--accent-2).
 * Remaining shades follow a lightness ramp typical of Mantine palettes.
 */
const accentColors: MantineColorsTuple = [
  '#e6f5f1', // 0 — near-white tint
  '#c3e6dc', // 1
  '#9dd4c6', // 2
  '#74c2af', // 3
  '#4db099', // 4
  '#2d9d83', // 5
  '#1a896d', // 6
  '#126b57', // 7 — --accent (primary)
  '#0f5a4a', // 8 — --accent-2
  '#0a3d32', // 9 — dark shade
];

export const theme = createTheme({
  primaryColor: 'accent',
  primaryShade: 7,

  colors: {
    accent: accentColors,
  },

  fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',

  // Radius defaults matching MVP feel
  defaultRadius: 'sm',
});
